import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function LoginPage() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [errorDetails, setErrorDetails] = useState('');
  const navigate = useNavigate();

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setErrorDetails('');
    try {
      const res = await axios.post('https://api.safenetbanking.com/api/login', form);
      console.log('LOGIN RESPONSE:', res.data); // DEBUG: Log the full response from backend
      if (res.data.token) {
        localStorage.setItem('token', res.data.token);
        // Decode token to check role (robust fallback if payload is not JSON)
        let isAdmin = false;
        try {
          const base64 = res.data.token.split('.')[1];
          const json = atob(base64.replace(/-/g, '+').replace(/_/g, '/'));
          const payload = JSON.parse(json);
          console.log('TOKEN PAYLOAD:', payload); // DEBUG: Log the decoded JWT payload
          isAdmin = payload.role === 'admin' || payload.isAdmin === true;
        } catch (e) {
          console.error('JWT DECODE ERROR:', e); // DEBUG: Log decode errors
        }
        if (isAdmin) {
          navigate('/admin');
        } else {
          navigate('/user-dashboard');
        }
      } else {
        setError(res.data.error || 'Login failed');
        setErrorDetails(res.data.message || '');
        console.error('LOGIN ERROR:', res.data.error || 'Login failed'); // DEBUG: Log error
      }
    } catch (err) {
      // Handle specific account status errors
      if (err.response?.status === 403) {
        if (err.response.data.error === 'Account closed' || err.response.data.error === 'Account disabled') {
          setError(err.response.data.error);
          setErrorDetails(err.response.data.message || 'Please contact customer support for assistance.');
        } else {
          setError(err.response.data.error || 'Access denied');
          setErrorDetails(err.response.data.message || '');
        }
      } else {
        setError('Login failed: ' + (err.response?.data?.error || err.message));
      }
      console.error('LOGIN ERROR:', err.response?.data || err.message); // DEBUG: Log error
    }
    setLoading(false);
  };

  return (
    <main className="auth-page login-page">
      <div className="auth-navbar"><a className="logo" href="/"><img src="/logo.jpg" alt="company logo" /></a>
        <div className="desktop-alternative">
          <p>Don't have an account?</p>
          <button className="transparent" onClick={() => navigate('/register')}>Register Here</button>
        </div>
      </div>
      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <div className="mobile-alternative">
            <p>Don't have an account?</p>
            <button className="transparent" type="button" onClick={() => navigate('/register')}>Register Here</button>
          </div>
          <div className="header">
            <h4>Financial freedom at your fingertips</h4>
            <h3>Sign in to your account</h3>
          </div>
          {error && (
            <div className="error-container" style={{ backgroundColor: '#ffebee', padding: '10px', borderRadius: '4px', marginBottom: '15px' }}>
              <h2 className="text-danger" style={{ color: '#d32f2f', margin: '0 0 5px 0', fontSize: '16px' }}>{error}</h2>
              {errorDetails && <p style={{ margin: 0, color: '#d32f2f' }}>{errorDetails}</p>}
            </div>
          )}
          <div className="form-control">
            <label>Email</label>
            <input type="email" name="email" required placeholder="e.g johndoe@email.com" value={form.email} onChange={handleChange} />
          </div>
          <div className="form-control">
            <label>Password</label>
            <div className="password-container">
              <input type="password" name="password" required placeholder="Enter your password" value={form.password} onChange={handleChange} />
            </div>
          </div>
          <div className="forgot-password"><button type="button" className="link" onClick={() => navigate('/forgot-password')}>Forgot Password?</button></div>
          <div className="submit-btn"><button className="blue long" type="submit" disabled={loading}>{loading ? 'Logging in...' : 'Login'}</button></div>
        </form>
        <div className="img"><img src="auth-img.0350100dc36c42bb4485.png" alt="register with us" /></div>
      </div>
    </main>
  );
}
